// Share: the Web Share API where there is one, otherwise the words are copied.

import { SEND_COPIED, SEND_COPY_FAILED, SHARE_MESSAGE, SHARE_TITLE, SHARED_TAG, sponsorLink } from './sponsor.js';
import { showToast } from './ui.js';

/** The canonical address (also in index.html's tags). */
export const SITE_URL = 'https://salsacount.bailabento.com/';

/** salsacount's own share message: its tagline, then what it is (DESIGN §10: everything shared ends "Free, by BailaBento."). */
export const APP_SHARE_TEXT = `See the count. Hear the count. ${SHARED_TAG}`;

/**
 * Open the system share sheet with `data`. True when it was shown (a dancer who closes it has still been offered it), false when there is
 * no share sheet or it failed, so the caller can copy instead.
 */
async function openShareSheet(data: ShareData): Promise<boolean> {
  if (typeof navigator.share !== 'function' || (typeof navigator.canShare === 'function' && !navigator.canShare(data))) return false;
  try {
    await navigator.share(data);
    return true;
  } catch (e) {
    return e instanceof DOMException && e.name === 'AbortError'; // the dancer closed the share sheet
  }
}

export async function shareApp(): Promise<void> {
  if (await openShareSheet({ title: 'salsacount', text: APP_SHARE_TEXT, url: SITE_URL })) return;
  try {
    await navigator.clipboard.writeText(SITE_URL);
    showToast('Link copied');
  } catch {
    showToast(`Copy this link: ${SITE_URL}`);
  }
}

/**
 * "Know an organiser? Send this" (DESIGN §10): the share sheet with the message and the tagged link, or, where there is none, the message
 * and the link copied, with a confirmation on screen and in the live region (showToast does both).
 */
export async function shareToOrganiser(): Promise<void> {
  const url = sponsorLink('tell_an_organiser');
  if (await openShareSheet({ title: SHARE_TITLE, text: SHARE_MESSAGE, url })) return;
  const message = `${SHARE_MESSAGE} ${url}`;
  try {
    await navigator.clipboard.writeText(message);
    showToast(SEND_COPIED);
  } catch {
    showToast(`${SEND_COPY_FAILED} ${message}`);
  }
}
